import { Controller } from "@hotwired/stimulus"

// Two jobs on the message list:
//  1) keep it scrolled to the newest message (on load + on each appended broadcast),
//  2) align each message left/right (daisyUI chat-start/chat-end) by comparing its
//     data-sender-id to the list's data-current-user-id. Alignment is done client-side so the
//     broadcast message partial stays viewer-agnostic (it never knows who's looking).
export default class extends Controller {
  static values = { currentUserId: Number, readUrl: String }

  connect() {
    this.render()
    // subtree: messages are appended into an inner container, not a direct child.
    this.observer = new MutationObserver(() => this.render())
    this.observer.observe(this.element, { childList: true, subtree: true })
  }

  disconnect() {
    this.observer?.disconnect()
    clearTimeout(this.readTimer)
  }

  render() {
    this.align()
    this.scrollToBottom()
    this.markRead()
  }

  // A message shown in the open, visible chat shouldn't linger as an unread bell notification.
  // Debounced; skipped when the tab is hidden (then the user isn't really looking → keep unread,
  // and the absence-email logic still applies).
  markRead() {
    if (!this.hasReadUrlValue || document.visibilityState !== "visible") return

    clearTimeout(this.readTimer)
    this.readTimer = setTimeout(() => {
      const token = document.querySelector('meta[name="csrf-token"]')?.content
      fetch(this.readUrlValue, {
        method: "PATCH",
        headers: { "X-CSRF-Token": token },
        credentials: "same-origin",
        keepalive: true,
      }).catch(() => {})
    }, 300)
  }

  align() {
    this.element.querySelectorAll("[data-sender-id]").forEach((el) => {
      const own = Number(el.dataset.senderId) === this.currentUserIdValue
      el.classList.toggle("chat-end", own)
      el.classList.toggle("chat-start", !own)
      // Colour the viewer's own bubbles (brand fill); the partial stays viewer-agnostic.
      el.querySelector(".chat-bubble")?.classList.toggle("chat-bubble-primary", own)
    })
  }

  scrollToBottom() {
    this.element.scrollTop = this.element.scrollHeight
  }
}
